import { render, staticRenderFns } from "./dance.vue?vue&type=template&id=649a8908&scoped=true"
import script from "./dance.vue?vue&type=script&lang=js"
export * from "./dance.vue?vue&type=script&lang=js"
import style0 from "./dance.vue?vue&type=style&index=0&id=649a8908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a8908",
  null
  
)

export default component.exports